@if (contractDetailsForm) {
  <form [formGroup]="contractDetailsForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="mb-3 text-secondary col-12">
        <small class="form-text text-secondary">Les champs marqués d'un * sont obligatoires. </small>
      </div>
      <!-- Dates -->
      <div class="mb-3 col-12 col-lg-6">
        <label class="text-secondary required">Date de début</label>
        <app-datepicker
          id="fieldBeginDate"
          formControlName="beginDate"
          [invalid]="submitted && (contractDetailsForm.errors?.datesOrder || contractDetailsForm.controls?.beginDate?.invalid)"
        ></app-datepicker>
        @if (submitted && contractDetailsForm.errors?.datesOrder) {
          <small class="form-text text-danger">La date de début est incohérente avec la date de fin.</small>
        }
        @if (submitted && !contractDetailsForm.controls?.beginDate?.errors?.required && contractDetailsForm.controls?.beginDate?.errors?.dateFormat) {
          <small class="form-text text-danger">La date de début est invalide.</small>
        }
        @if (submitted && contractDetailsForm.controls?.beginDate?.errors?.required) {
          <small class="form-text text-danger">La date de début est requise.</small>
        }
      </div>
      <div class="mb-3 col-12 col-lg-6">
        <label class="text-secondary required">Date de fin</label>
        <app-datepicker
          id="fieldEndDate"
          formControlName="endDate"
          [invalid]="submitted && (contractDetailsForm.errors?.datesOrder || contractDetailsForm.controls?.endDate?.invalid)"
        ></app-datepicker>
        @if (submitted && contractDetailsForm.errors?.datesOrder) {
          <small class="form-text text-danger">La date de fin est incohérente avec la date de début.</small>
        }
        @if (submitted && !contractDetailsForm.controls?.endDate?.errors?.required && contractDetailsForm.controls?.endDate?.errors?.dateFormat) {
          <small class="form-text text-danger">La date de fin est invalide.</small>
        }
        @if (submitted && contractDetailsForm.controls?.endDate?.errors?.required) {
          <small class="form-text text-danger">La date de fin est requise.</small>
        }
      </div>
      <!-- Objectif -->
      <div class="mb-3 col-12">
        <label class="text-secondary required">Objectif principal</label>
        <textarea
          formControlName="mainPurpose"
          class="form-control"
          [class.is-invalid]="submitted && contractDetailsForm.controls.mainPurpose.invalid"
        ></textarea>
        @if (submitted && contractDetailsForm.controls?.mainPurpose?.errors?.required) {
          <small class="form-text text-danger">L'objectif principal est requis.</small>
        }
      </div>
      <!-- Projet et Actions -->
      <div class="mb-3 col-12">
        <label class="text-secondary">Projet</label>
        <textarea formControlName="project" class="form-control"></textarea>
      </div>
      <div class="mb-3 col-12">
        <label class="text-secondary">Actions à réaliser</label>
        <textarea formControlName="actionsToPerform" class="form-control"></textarea>
      </div>
      @if (!isWorkflowedContract) {
        <!-- Etat et date d'état -->
        <div class="mb-3 col-12 col-lg-6">
          <label class="text-secondary required">État</label>
          <select class="form-select" formControlName="status" [class.is-invalid]="submitted && contractDetailsForm.controls.status.invalid">
            @if (!contractDetailsForm.value.status) {
              <option [ngValue]="" selected hidden></option>
            }
            @for (status of statusMap | keyvalue: stringAscOrder; track $index) {
              <option [ngValue]="status.value">
                {{ status.value }}
              </option>
            }
          </select>
          @if (submitted && contractDetailsForm.controls?.status?.errors?.required) {
            <small class="form-text text-danger">L'état est requis.</small>
          }
        </div>
        <div class="mb-3 col-12 col-lg-6">
          <label class="text-secondary">Date d'état</label>
          <app-datepicker id="fieldBeginDate" formControlName="statusDate"></app-datepicker>
        </div>
        <!-- Atteinte -->
        <div class="mb-3 col-12 col-lg-6">
          <label class="text-secondary">Atteinte</label>
          <select class="form-select" formControlName="achievement">
            @if (!contractDetailsForm?.controls?.achievement?.value) {
              <option [ngValue]="" selected hidden></option>
            }
            @for (achievement of achievements | keyvalue: stringAscOrder; track $index) {
              <option [ngValue]="achievement.key">
                {{ achievement.value }}
              </option>
            }
          </select>
        </div>
      }
    </div>
    <!-- Boutons actions -->
    @if (isWorkflowedContract) {
      <div class="row d-flex justify-content-end">
        <div
          class="d-grid col-3 col-md-6 col-lg-3 mb-1"
          *hasPermission="'CAN_DELETE'; subject: contract; context: workflowedContractPermissionContext"
        >
          @if (!isCreation) {
            <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="delete()">
              <fa-icon icon="trash"></fa-icon>
              <span class="ms-3 d-none d-md-block">Supprimer</span>
            </button>
          }
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="this.closeModal.emit()">
            <fa-icon icon="ban"></fa-icon>
            <span class="ms-3 d-none d-md-block">Annuler</span>
          </button>
        </div>
        <!-- ********************************************************************************************* -->
        <!-- * WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED W * -->
        <!-- * WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED W * -->
        <!-- ********************************************************************************************* -->
        <div
          class="col-3 col-md-6 col-lg-3 mb-1"
          *hasPermission="
            $any([
              'CAN_EDIT',
              workflowedContractPermissionContext + '_CAN_BENEF_SIGN',
              workflowedContractPermissionContext + '_CAN_ROLLBACK',
              workflowedContractPermissionContext + '_CAN_VALIDATE',
              workflowedContractPermissionContext + '_CAN_SIGN',
              workflowedContractPermissionContext + '_CAN_REJECT',
              workflowedContractPermissionContext + '_CAN_CLOSE',
              workflowedContractPermissionContext + '_CAN_REOPEN',
            ]);
            subject: contract;
            context: workflowedContractPermissionContext
          "
        >
          <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary w-auto" id="dropdownPrint" type="button" ngbDropdownToggle>
              <fa-icon icon="directions"></fa-icon>
              <span class="mx-3">Actions</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownPrint">
              <button
                class="dropdown-item"
                type="submit"
                *hasPermission="'CAN_EDIT'; subject: contract; context: workflowedContractPermissionContext"
              >
                Sauvegarder
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedBeneficiary)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_BENEF_SIGN');
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Signer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Creation)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_ROLLBACK');
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Retour en Création
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.ValidatedMetro)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_VALIDATE');
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Valider
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedMetro)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_SIGN');
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Signer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Unvalidated)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_REJECT');
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Rejeter
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Done)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_CLOSE');
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Terminer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedMetro)"
                *hasPermission="
                  $any(workflowedContractPermissionContext + '_CAN_REOPEN');
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Rouvrir le contrat
              </button>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!isWorkflowedContract) {
      <div class="row d-flex justify-content-end">
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1" *appOnlyGroups="['ADMIN']">
          @if (!isCreation) {
            <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="delete()">
              <fa-icon icon="trash"></fa-icon>
              <span class="ms-3 d-none d-md-block">Supprimer</span>
            </button>
          }
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="closeModal.emit()">
            <fa-icon icon="ban"></fa-icon>
            <span class="ms-3 d-none d-md-block">Annuler</span>
          </button>
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+']"
            class="btn btn-primary d-flex justify-content-center"
            type="submit"
            [disabled]="!contractTypeIsSelected"
          >
            <fa-icon icon="save"></fa-icon>
            <span class="ms-3 d-none d-md-block">Sauvegarder</span>
          </button>
        </div>
      </div>
    }
  </form>
} @else {
  <div class="bg-white p-xl-5 p-2"></div>
}
